import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRoomContext } from '../../RoomContext';
import * as toolareaActions from '../../store/actions/toolareaActions';

const CloseBtn = (props) =>
{
	const {
		toggleToolArea,
		setToolTab
	} = props;

	const closeDrawer = () =>
	{
		toggleToolArea();
		setToolTab('');
		window.parent.postMessage({ cmd: 'participantTabClosed' }, '*');
	};

	return (

		<img src='icons/close.svg' alt='close' className='pointer' onClick={closeDrawer} />
	);

};

CloseBtn.propTypes =
{
	setToolTab     : PropTypes.func,
	toggleToolArea : PropTypes.func
};
const makeMapStateToProps = () =>
{
	// const hasPermission = makePermissionSelector(permissions.MODERATE_ROOM);
	const mapStateToProps = () => ({

	});

	return mapStateToProps;

};

const mapDispatchToProps = (dispatch) => ({
	setToolTab : (tab) =>
		dispatch(toolareaActions.setToolTab(tab)),
	toggleToolArea : () =>
	{
		dispatch(toolareaActions.toggleToolArea());
	}
});

export default withRoomContext(connect(
	makeMapStateToProps,
	// mapStateToProps,
	mapDispatchToProps,
	null
)((CloseBtn)));